import { ref, type Ref } from 'vue'

/**
 * Reactive flag indicating whether user interaction has unlocked audio playback.
 * Some browsers block autoplay until a user gesture occurs. This flag becomes
 * true after a click or keydown event.
 */
export const audioUnlocked: Ref<boolean> = ref(false)

/**
 * Mark audio as unlocked due to a user gesture.
 */
function unlockAudio(): void {
  audioUnlocked.value = true
}

if (typeof window !== 'undefined') {
  try {
    window.addEventListener('click', unlockAudio, { once: true })
    window.addEventListener('keydown', unlockAudio, { once: true })
  } catch (error) {
    console.error('Error unlocking audio', error)
  }
}
